import { z } from "zod";

export enum PriorAuthorizationCommsChannel {
  EMAIL = "email",
  FAX = "fax",
  CALL = "call",
}

export enum PriorAuthorizationCommsStatus {
  SENT = "sent",
  FAILED = "failed",
}

export enum PriorAuthorizationCommsStep {
  RESEND_FAX = "resend_fax",
  SEND_FOLLOW_UP_FAX = "send_follow_up_fax",
}

export const priorAuthorizationCommsSchema = z.object({
  id: z.string().uuid(),
  priorAuthorizationId: z.string().uuid(),
  groupId: z.string().uuid(),
  taskId: z.string().uuid().nullable(),
  faxId: z.string().uuid().nullable(),
  channel: z.nativeEnum(PriorAuthorizationCommsChannel),
  status: z.nativeEnum(PriorAuthorizationCommsStatus),
  recipient: z.string().nullable(),
  sentAt: z.string(),
  label: z.string().nullable(),
  error: z.string().nullable(),
  gcsPath: z.string().nullable(),
  pdfFilename: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
});

export type PriorAuthorizationComms = z.infer<typeof priorAuthorizationCommsSchema>;

export const priorAuthorizationCommsListResponseSchema = z.array(priorAuthorizationCommsSchema);

export type PriorAuthorizationCommsPreviewResult = {
  channel: "fax";
  title: string;
  gcsPath: string;
  pdfFilename: string;
  recipient?: string;
  sentAt?: string;
};

export const priorAuthorizationCommsStepSchema = z.nativeEnum(PriorAuthorizationCommsStep);

export const runPriorAuthorizationCommsStepInputSchema = z.object({
  authDisplayId: z.string(),
  step: priorAuthorizationCommsStepSchema,
});

export const getPriorAuthorizationCommsPreviewInputSchema = z.object({
  authDisplayId: z.string(),
  sentAt: z.string().optional(),
});

export const openAuthorizationTrackingInputSchema = z.object({
  authDisplayId: z.string(),
  taskId: z.string().uuid().optional(),
});
